module.exports = __webpack_public_path__ + "static/media/project4.78f222e4.jpg";